import type * as React from "react";
import type { SpaceAwareNavigation } from "./SpaceAwareNavigation/SpaceAwareNavigation";
import { useSpaceAwareNavigation } from "./SpaceAwareNavigation/useSpaceAwareNavigation";
interface SpaceAwareNavigateProps {
    render: (navigation: SpaceAwareNavigation) => React.ReactElement | null;
}
export const SpaceAwareNavigate: React.FC<SpaceAwareNavigateProps> = ({ render }) => {
    const navigation = useSpaceAwareNavigation();
    return render(navigation);
};
SpaceAwareNavigate.displayName = "SpaceAwareNavigate"
export default SpaceAwareNavigate;
